exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-menu-item,\n:host {\n  position: relative;\n  width: 430px;\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n}\n.collection {\n  width: 100%;\n  padding: 25px 10px;\n  box-sizing: border-box;\n  height: 100%;\n}\n.collection .allFilters {\n  overflow-y: auto;\n  height: 100%;\n  padding-right: 10px;\n}\n.collection ansyn-checkbox {\n  margin-bottom: 10px;\n}\n::-webkit-scrollbar {\n  width: 7px;\n}\n::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\n::-webkit-scrollbar-thumb {\n  -webkit-box-shadow: inset -1px -1px 0 rgba(0, 0, 0, 0.05), inset 1px 1px 0 rgba(0, 0, 0, 0.05);\n  border: 4px solid transparent;\n  background-clip: padding-box;\n  border-radius: 2px;\n  background: white -webkit-gradient(linear, 0 0, 0 100%, color-stop(0.5, rgba(255, 255, 255, 0.2)), color-stop(0.5, transparent), to(transparent));\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/filters/components/filters-collection/filters-collection.component.less
// module id = ../../../../../src/app/packages/menu-items/filters/components/filters-collection/filters-collection.component.less
// module chunks = main